// extracted by mini-css-extract-plugin
module.exports = {"list":"list--2De_r","item":"item--_6CVm","title":"title--2ckC2"};